import { DetailsCard } from "components";
import { TYRE_LOCATIONS } from "models";
import { TyreTable } from "modules/AppointmentDetails/components/VehicleTyres/components";
import "modules/AppointmentDetails/components/VehicleTyres/VehicleTyres.scss";

import type { SectionMenu } from "components";
import type { Appointment } from "models";

type VehicleTyresProp = {
  appointment: Appointment;
  isExpanded: boolean;
  isTyreStatusVisible: boolean;
  sectionMenu: SectionMenu;
};

export const VehicleTyres = ({ appointment, isExpanded, isTyreStatusVisible, sectionMenu }: VehicleTyresProp) => {
  const vehicleTyres = appointment.car?.tyres?.filter(tyre => tyre.location === TYRE_LOCATIONS.OnVehicle) ?? [];
  if (!vehicleTyres.length || !isTyreStatusVisible) return null;

  return (
    <DetailsCard
      sectionMenuId={sectionMenu.id}
      title={sectionMenu.count ? `${sectionMenu.title} (${sectionMenu.count})` : sectionMenu.title}
      icon={sectionMenu.icon}
      isExpanded={isExpanded}
    >
      <div className="VehicleTyres-container">
        <div className="TyreGroup">
          <div className="VehicleTyres">
            {vehicleTyres.length > 0 && <TyreTable tyres={vehicleTyres} appointment={appointment} tyreLocation={TYRE_LOCATIONS.OnVehicle} />}
          </div>
        </div>
      </div>
    </DetailsCard>
  );
};
